module.exports = __webpack_public_path__ + "img/首页-小房书@2x.dff950b0.png";